import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout = ({children, onChangeLanguage, language}) => {
    const headerClassName = "site-header";
    return (
        <div className="content-container">
            <Header onChangeLanguage={onChangeLanguage} headerClassName={headerClassName} language={language}/>
            <div className="body-content">
                {children}
            </div>
            <Footer/>
        </div>
    )
}

export default MainLayout
